import type { RxJsonSchema } from 'rxdb';
import type { LineandSectionPropertiesList } from './lineandSectionPropertiesDetails.types';

export const lineandSectionPropertiesListSchema: RxJsonSchema<LineandSectionPropertiesList> = {
  type: 'object',
  version: 2,
  description: 'describes line and section list',
  primaryKey: 'assetId',
  properties: {
    assetId: { type: 'string', maxLength: 36 },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    assetSection: {
      type: 'array',
      items: {
        type: ['object', 'null'],
        properties: {
          fromMajorAsset: { type: ['string', 'null'] },
          toMajorAsset: { type: ['string', 'null'] },
          temperature: { type: ['number', 'null'] },
          ksi: { type: ['number', 'null'] },
          name: { type: ['string', 'null'] },
          description: { type: ['string', 'null'] },
          fkSectionDefinition: { type: ['number', 'null'] },
          assetSectionArea: {
            type: 'array',
            items: {
              type: ['object', 'null'],
              properties: {
                fkArea: { type: ['number', 'null'] },
                fkAssetSection: { type: ['number', 'null'] },
                pkAssetSectionArea: { type: ['number', 'null'] },
              },
            },
          },
          assetSectionMetalicPropertyValue: {
            type: 'array',
            items: {
              type: ['object', 'null'],
              properties: {
                dOd: { type: ['number', 'null'] },
                sAllowableUnitStress: { type: ['string', 'null'] },
                pkAssetSectionMetalicPropertyValue: { type: ['number', 'null'] },
                designCorrosionAllowance: { type: ['number', 'null'] },
                eLongitudeQualityFactor: { type: ['number', 'null'] },
                pInternalDesignGause: { type: ['number', 'null'] },
              },
            },
          },
          assetSectionPropertyValue: {
            type: 'array',
            items: {
              type: ['object', 'null'],
              properties: {
                pkAssetSectionPropertyValue: { type: ['number', 'null'] },
                value: { type: ['string', 'null'] },
                fkAssetSection: { type: ['number', 'null'] },
                fkSectionPropertyDefinition: { type: ['number', 'null'] },
              },
            },
          },
          sectionCmlattribute: {
            type: 'array',
            items: {
              type: ['object', 'null'],
              properties: {
                cmlcode: { type: ['string', 'null'] },
                surface: { type: ['string', 'null'] },
                access: { type: ['string', 'null'] },
                active: { type: ['boolean', 'null'] },
                alarm: { type: ['number', 'null'] },
                fitting: { type: ['string', 'null'] },
                id: { type: ['number', 'null'] },
                readingUser: { type: ['string', 'null'] },
                refMeasurment: { type: ['string', 'null'] },
                cubeId: { type: ['number', 'null'] },
                dateReading: { type: ['string', 'null'] },
                sectionCmlattributeValue: {
                  type: 'array',
                  items: {
                    type: ['object', 'null'],
                    properties: {
                      at3: { type: ['number', 'null'] },
                      at6: { type: ['number', 'null'] },
                      at9: { type: ['number', 'null'] },
                      at12: { type: ['number', 'null'] },
                      fkSectionCmlattribute: { type: ['number', 'null'] },
                      utMeasurement: { type: ['number', 'null'] },
                      id: { type: ['number', 'null'] },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    assetArea: {
      type: 'array',
      items: {
        type: ['object', 'null'],
        properties: {
          assetId: { type: ['number', 'null'] },
          areaId: { type: ['number', 'null'] },
          pcsId: { type: ['string', 'null'] },
          assetName: { type: ['string', 'null'] },
          assetCategory: { type: ['number', 'null'] },
          site: { type: ['number', 'null'] },
          discipline: { type: ['number', 'null'] },
          layer: { type: ['number', 'null'] },
          parentAreaId: { type: ['number', 'null'] },
          parentAreaPcsId: { type: ['string', 'null'] },
          pkAssetArea: { type: ['number', 'null'] },
          areaName: { type: ['string', 'null'] },
          namePcsid: { type: ['string', 'null'] },
          fkAreaType: { type: ['number', 'null'] },
        },
      },
    },
  },
};
